/**
 * @file 项目上下文 projectId（仅 URL 来源）
 * @description 判断「当前是否处于项目上下文」
 */

import {useSearchParams} from 'react-router-dom';
import type {ProjectId} from '@/types';

export const useUrlProjectId = (): ProjectId | null => {
    const [searchParams] = useSearchParams();
    return searchParams.get('projectId') || null;
};
